import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

export const StoreWriteOffPages = {
  list: 'ListStoreWriteOff',
  add: 'AddStoreWriteOff',
  edit: 'EditStoreWriteOff',
}

const { t } = i18n.global

const title = t('pages.listStoreWriteOff')
const path = '/store-write-off'
const breadcrumb = [{ title, path }]

const Add: RouteRecordRaw = {
  path: 'add',
  name: StoreWriteOffPages.add,
  component: () => import('@/pages/mainPageWithRoute/store-write-off/AddStoreWriteOffPage.vue'),
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: StoreWriteOffPages.edit,
  component: () => import('@/pages/mainPageWithRoute/store-write-off/EditStoreWriteOffPage.vue'),
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: StoreWriteOffPages.list,
  component: () => import('@/pages/mainPageWithRoute/store-write-off/ListStoreWriteOffPage.vue'),
  meta: { title, requiresAuth: true },
}

export const StoreWriteOffs: RouteRecordRaw = {
  path,
  name: 'StoreWriteOffs',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Edit, Add],
}
